module.exports = __webpack_public_path__ + "static/media/Dashboard.5c5ceaf8.png";